import React, { useEffect, useRef, useState } from "react";
import highBurgerGta from "../../../assets/mp4/highBurgerGta.mp4";
import "../index.css";
import ModalVideo from "../../ModalVideo";
export default function HighBurgerGta() {
  const [linkVideo, setLinkVideo] = useState("");
  return (
    <>
      <ModalVideo linkVideo={linkVideo} setLinkVideo={setLinkVideo} />
      <div className="w-100 h-100 position-relative">
        <video autoPlay loop muted className="videoBackground">
          <source src={highBurgerGta} type="video/mp4" />
          Seu navegador não suporta vídeos HTML5.
        </video>

        <div className="container">
          <div
            className="tituloHome tituloHome1 text-center "
            onClick={() => {
              setLinkVideo(
                "https://player.vimeo.com/video/809801384?h=97a89d41a0"
              );
            }}
            style={{ maxWidth: 700 }}
          >
            High Burger GTA
          </div>
          <div className="background"></div>
        </div>
      </div>
    </>
  );
}
